/**
 * The signing template is fixed by the API contract and must match byte for
 * byte on the server, which re-derives it from the posted fields.
 *
 *   tism.indexsy.com airdrop
 *   Solana: <solanaAddress>
 *   EVM: <evmAddress lowercase>
 *   Issued: <ISO-8601 UTC>
 *
 * The same string is signed by both wallets. Issued must be within 15 minutes.
 */
export const MESSAGE_TTL_MS = 15 * 60 * 1000;

export function buildAirdropMessage(
  solanaAddress: string,
  evmAddress: string,
  issuedAt: Date = new Date(),
): string {
  return [
    "tism.indexsy.com airdrop",
    `Solana: ${solanaAddress}`,
    `EVM: ${evmAddress.toLowerCase()}`,
    `Issued: ${issuedAt.toISOString()}`,
  ].join("\n");
}
